export const COMPETITIONS_ROUTER_ROOT = '/raffles';
export const COMPETITIONS_ROUTER_NEW = COMPETITIONS_ROUTER_ROOT + '/new';
export const COMPETITIONS_ROUTER_EDIT = COMPETITIONS_ROUTER_ROOT + '/edit/:id';



// WEBPACK FOOTER //
// ./src/components/Competitions/constants.js